export const SWITCH_MAP = "SWITCH_MAP";
export const SWITCH_LIST = "SWITCH_LIST";
export const GET_PS_DATA = "GET_PS_DATA";
export const GET_DAM_DATA = "GET_DAM_DATA";
export const SET_CURRENT_DAM = "SET_CURRENT_DAM";
export const CLEAR_CURRENT_DAM = "CLEAR_CURRENT_DAM";
export const SET_MAP_ZOOM = "SET_MAP_ZOOM";
export const SET_MAP_COORDINATES = "SET_MAP_COORDINATES";
export const SET_INFO_WINDOW_OPEN = "SET_INFO_WINDOW_OPEN";
export const SET_INFO_WINDOW_CLOSE = "SET_INFO_WINDOW_CLOSE";
export const SET_ACTIVE_STATION = "SET_ACTIVE_STATION";
export const SET_DAM_ERROR = "SET_DAM_ERROR";
export const RESET_DASHBOARD_STATE = "RESET_DASHBOARD_STATE";
export const SET_MAP_EVENTS_VIEW_OPEN = "SET_MAP_EVENTS_VIEW_OPEN";
export const SET_MAP_DATA_FILTER = "SET_MAP_DATA_FILTER";
export const CLEAR_MAP_DATA_FILTER = "CLEAR_MAP_DATA_FILTER";
export const SET_PS_DATA_FILTER = "SET_PS_DATA_FILTER";
export const GET_SHOW_SENSOR_ICONS = "GET_SHOW_SENSOR_ICONS"
export const SET_SHOW_SENSOR_ICONS = "SET_SHOW_SENSOR_ICONS"